import { UsersIcon } from '@mm/icons';
import classNames from 'classnames';
import React from 'react';
import { LinkedContact } from '@mm/state/interfaces/contacts';
import { AccordionItem } from '@mm/components';
import { ChannelIcon } from '../../ChannelIcon';
import './LinkedContacts.pcss';

interface Props {
  className?: string;
  linkedContacts?: LinkedContact[];
  onContactClick?: (contact: LinkedContact) => void;
}

export const LinkedContacts = ({
  className,
  linkedContacts,
  onContactClick = () => {},
}: Props) => {
  const containerClassName = classNames(
    className,
    'live-chat--linked-contacts',
  );
  const linkedContactsNumber = linkedContacts?.length;

  if (!linkedContacts?.length) {
    return null;
  }
  return (
    <div className={containerClassName}>
      <AccordionItem
        icon={
          <UsersIcon
            color="#A5BBD4"
            className="contact-details__nested-header-icon"
          />
        }
        title="Linked Contacts"
        count={linkedContactsNumber}
        closeOnOutsideClick={false}
        className="contact-details__nested-accordion-item"
        headingClassName="contact-details__accordion-item-heading"
        withBorder={false}
      >
        {linkedContacts?.map(c => (
          <div
            key={c.id}
            className="live-chat--linked-contacts__contact"
            onClick={() => onContactClick(c)}
          >
            <div className="live-chat--linked-contacts__contact-channel-icon">
              <ChannelIcon remoteUserId={c.remoteId} />
            </div>
            {c.firstName} {c.lastName}
          </div>
        ))}
      </AccordionItem>
    </div>
  );
};
